import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {Alert, Box, Button, CircularProgress, Container, Fab} from "@mui/material";
import {Comment, Notebook} from "../types";
import {getNotebookByToken} from "../services/api";
import {NotebookViewer} from "../components/NotebookViewer";
import DownloadIcon from '@mui/icons-material/Download';

export const ReviewPage: React.FC = () => {
    const {token} = useParams<{ token: string }>();
    const [notebook, setNotebook] = useState<Notebook | null>(null);
    const [comments, setComments] = useState<Comment[]>([]);

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                if (token) {
                    const notebook = await getNotebookByToken(token);
                    setNotebook(notebook);
                    setComments(notebook.comments);
                }
            } catch (err) {
                setError("Ошибка при загрузке ноутбука");
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [token]);

    if (loading) {
        return (
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                minHeight="100vh"
            >
                <CircularProgress/>
            </Box>
        );
    }

    if (error) {
        return (
            <Container>
                <Alert severity="error" sx={{mt: 2}}>
                    {error}
                </Alert>
            </Container>
        );
    }

    if (!notebook) {
        return (
            <Container>
                <Alert severity="error" sx={{mt: 2}}>
                    Ноутбук не найден
                </Alert>
            </Container>
        );
    }

    const handleDownloadNotebook = () => {
        if (!notebook) return;

        try {
            const blob = new Blob([notebook.downloadContent], {type: 'application/json'});
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `${notebook.title || 'notebook'}_reviewed.ipynb`;
            document.body.appendChild(a);
            a.click();
            setTimeout(() => {
                document.body.removeChild(a);
                URL.revokeObjectURL(url);
            }, 100);
        } catch (error) {
            console.error('Ошибка при скачивании ноутбука:', error);
        }
    };

    return (

        <Container maxWidth="lg" sx={{py: 4}}>
            <Fab
                color="primary"
                aria-label="download"
                onClick={handleDownloadNotebook}
                sx={{
                    position: "fixed",
                    right: 16,
                    bottom: 16,
                    zIndex: 1300,
                    bgcolor: "#071a3d",
                    "&:hover": {
                        bgcolor: "#3E475E",
                    },
                    color: "#FFFFFF",
                }}
            >
                <DownloadIcon/>
            </Fab>
            <NotebookViewer
                notebook={notebook}
                comments={comments}
                isReadOnly={true}
            />
        </Container>
    );
};
